import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExclamationTriangleIcon, PhoneIcon } from '@heroicons/react/24/outline'
import { SERVICE_CENTER_PHONE_DISPLAY, SERVICE_CENTER_PHONE_TEL } from '../../../../../../constants/phoneNumbers'

interface GasEmergencyScreenProps {
  onBack: () => void
}

const GasEmergencyScreen = ({ onBack }: GasEmergencyScreenProps) => {
  const { t } = useTranslation()
  const tips = t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_SAFETY_TIPS', { returnObjects: true }) as string[]

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 12,
          padding: '16px 20px',
          borderRadius: 12,
          border: '1px solid #FFCDD2',
          background: '#FFEBEE',
          marginBottom: 24,
        }}
      >
        <ExclamationTriangleIcon style={{ width: 28, height: 28, color: '#E53935', flexShrink: 0 }} />
        <div>
          <h3 style={{ margin: '0 0 4px', fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47' }}>
            {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_TITLE')}
          </h3>
          <p style={{ margin: 0, fontSize: '0.875rem', color: '#C62828', fontWeight: 500 }}>
            {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_SUBTITLE')}
          </p>
        </div>
      </div>

      <p style={{ margin: '0 0 20px', fontSize: '0.875rem', color: '#6b7280', lineHeight: 1.6 }}>
        {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_BODY')}
      </p>

      <a
        href={`tel:${SERVICE_CENTER_PHONE_TEL}`}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          padding: '16px 24px',
          borderRadius: 8,
          background: '#E53935',
          color: '#fff',
          fontSize: '1rem',
          fontWeight: 600,
          textDecoration: 'none',
          marginBottom: 16,
        }}
      >
        <PhoneIcon style={{ width: 22, height: 22 }} />
        {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_CALL_CTA', { phone: SERVICE_CENTER_PHONE_DISPLAY })}
      </a>

      <div
        style={{
          padding: '12px 16px',
          borderRadius: 8,
          border: '1px solid #FFE082',
          background: '#FFF8E1',
          marginBottom: 24,
        }}
      >
        <p style={{ margin: 0, fontSize: '0.875rem', fontWeight: 600, color: '#B26A00' }}>
          {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_112_WARNING')}
        </p>
      </div>

      <ul style={{ margin: '0 0 32px', paddingLeft: 20, color: '#6b7280', fontSize: '0.875rem', lineHeight: 1.7 }}>
        {Array.isArray(tips) && tips.map((tip) => (
          <li key={tip}>{tip}</li>
        ))}
      </ul>

      <button
        type="button"
        onClick={onBack}
        style={{
          padding: '9px 24px',
          borderRadius: 4,
          border: '1px solid #E0E0E0',
          background: '#fff',
          color: '#6b7280',
          fontSize: '0.875rem',
          fontWeight: 500,
          cursor: 'pointer',
        }}
      >
        {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_BACK')}
      </button>
    </div>
  )
}

export default GasEmergencyScreen
